/** Tailwind class sets — brand refresh store list item. Legacy when flag is off. */

export const BRAND_REFRESH_ADDRESS_MAX_CHARS = 25;

export const formatBrandRefreshStoreDistance = (distance) => {
  if (!distance) {
    return distance;
  }

  return String(distance).replace(/\s*mi\b/i, ' Miles');
};

/** Mobile: cut address after max chars and append ... */
export const truncateBrandRefreshStoreAddress = (
  address,
  maxChars = BRAND_REFRESH_ADDRESS_MAX_CHARS
) => {
  if (!address || address.length <= maxChars) {
    return address;
  }
  return `${address.slice(0, maxChars)}...`;
};

/**
 * Brand refresh phone display: +1 (213) 262 0434
 * Falls back to raw phone when not a 10/11-digit NANP number.
 */
export const formatBrandRefreshStorePhone = (phone) => {
  if (!phone) {
    return phone;
  }

  const digits = String(phone).replace(/\D/g, '');
  let national = digits;

  if (digits.length === 11 && digits.charAt(0) === '1') {
    national = digits.slice(1);
  } else if (digits.length !== 10) {
    return phone;
  }

  const area = national.slice(0, 3);
  const mid = national.slice(3, 6);
  const last = national.slice(6, 10);
  return `+1 (${area}) ${mid} ${last}`;
};

export const LIST_ITEM_WRAPPER_LEGACY =
  'hover:bg-light dark:hover:bg-darkDry border-b-[1px] border-light dark:border-darkDry';

export const getListItemWrapperClass = (styles, br) =>
  br ? '' : `${styles.listItemWrapper} ${LIST_ITEM_WRAPPER_LEGACY}`;

export const getListItemContainerClass = (styles, br) =>
  br ? '' : `${styles.listItemContainer} md:py-6 py-2 px-4`;
